import React from 'react';
import Box from '@mui/material/Box';
// import { useMediaQuery, useTheme } from '@mui/system';

// eventCardUtils.js
export const planeCard = [
	{ key: 'eventC1', eventType: 1, src: 'linear-gradient(103deg, #DE7BAC 0.38%, #E39FD7 98.53%)' },
	{ key: 'eventC2', eventType: 2, src: 'linear-gradient(281deg, #8EDAEF 1.51%, #3DA1C1 98.71%)' },
	{ key: 'eventC3', eventType: 3, src: 'linear-gradient(281deg, #853D69 1.51%, #B16995 98.71%)' },
	{ key: 'eventC4', eventType: 4, src: 'linear-gradient(281deg, #FFC543 1.51%, #E19C00 98.71%)' },
	{ key: 'eventC5', eventType: 5, src: 'linear-gradient(281deg, #366976 1.51%, #5796A7 98.71%)' },
	{ key: 'eventC6', eventType: 6, src: 'linear-gradient(103deg, #702DDD 0.38%, #9158F1 98.53%)' }
];

// Define the design elements for each event type

export const getDesignElements = (eventType, requestT, upMD = false) =>
{
	const elements = {
		1 : [
			{ src: '/images/icons/Images/star.svg', top: (requestT === 'viewEvent' && upMD) ? '10px' : '24px', right: (requestT === 'viewEvent' && upMD) ? '60px' : '52px', width: (requestT === 'viewEvent' && upMD) ? '30px' : '16px', height: (requestT === 'viewEvent' && upMD) ? '30px' : '16px' },
			{ src: '/images/icons/Images/yellowBalloon.svg', top: '30px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '70px' : '40px', height: (requestT === 'viewEvent' && upMD) ? '70px' : '60px' },
			{ src: '/images/icons/Images/blueBalloon.svg', top: '40px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '100px' : '70px', height: (requestT === 'viewEvent' && upMD) ? '100px' : '76px' },
			{ src: '/images/icons/Images/bigCake.svg', bottom: '0px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '120px' : '64px', height: (requestT === 'viewEvent' && upMD) ? '120px' : '64px' }

		],
		2 : [
			{ src: '/images/icons/Images/blueBox.svg', bottom: '-10px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '120px' : '64px', height: (requestT === 'viewEvent' && upMD) ? '120px' : '64px' },
			{ src: '/images/icons/Images/star.svg', top: '20px', right: (requestT === 'viewEvent' && upMD) ? '84px' : '60px', width: (requestT === 'viewEvent' && upMD) ? '20px' : '8px', height: (requestT === 'viewEvent' && upMD) ? '20px' : '8px' },
			{ src: '/images/icons/Images/balloon.svg', top: '16px', right: (requestT === 'viewEvent' && upMD) ? '32px' : '24px', width: (requestT === 'viewEvent' && upMD) ? '60px' : '32px', height: (requestT === 'viewEvent' && upMD) ? '100px' : '60px' },
			{ src: '/images/icons/Images/star.svg', top: '10px', right: (requestT === 'viewEvent' && upMD) ? '10px' : '14px', width: (requestT === 'viewEvent' && upMD) ? '24px' : '12px', height: (requestT === 'viewEvent' && upMD) ? '24px' : '12px' },
			{ src: '/images/icons/Images/star.svg', top: '40px', right: (requestT === 'viewEvent' && upMD) ? '11px' : '16px', width: (requestT === 'viewEvent' && upMD) ? '30px' : '16px', height: (requestT === 'viewEvent' && upMD) ? '30px' : '16px' }
		],
		3 : [
			{ src: '/images/icons/Images/balloon.svg', top: '20px', right: (requestT === 'viewEvent' && upMD) ? '52px' : '34px', width: (requestT === 'viewEvent' && upMD) ? '60px' : '50px', height: (requestT === 'viewEvent' && upMD) ? '110px' : '90px' },
			{ src: '/images/icons/Images/blueBox.svg', bottom: '0px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '120px' : '102px', height: (requestT === 'viewEvent' && upMD) ? '120px' : '102px' }
		],
		4 : [
			{ src: '/images/icons/Images/balloon.svg', top: '20px', right: '34px', width: (requestT === 'viewEvent' && upMD) ? '90px' : '50px', height: (requestT === 'viewEvent' && upMD) ? '136px' : '90px' },
			{ src: '/images/icons/Images/cheeriCake.svg', bottom: '0px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '104px' : '84px', height: (requestT === 'viewEvent' && upMD) ? '94px' : '74px' }
		],
		5 : [
			{ src: '/images/icons/Images/balloon.svg', top: '20px', right: '34px', width: (requestT === 'viewEvent' && upMD) ? '90px' : '50px', height: (requestT === 'viewEvent' && upMD) ? '136px' : '90px' },
			{ src: '/images/icons/Images/halfBox.svg', bottom: '0px', right: '-22px', width: (requestT === 'viewEvent' && upMD) ? '74px' : '64px', height: (requestT === 'viewEvent' && upMD) ? '74px' : '64px' },
			{ src: '/images/icons/Images/blue2.svg', bottom: '-4px', right: (requestT === 'viewEvent' && upMD) ? '30px' : '24px', width: (requestT === 'viewEvent' && upMD) ? '74px' : '64px', height: (requestT === 'viewEvent' && upMD) ? '74px' : '64px' }
		],
		6 : [
			{ src: '/images/icons/Images/star.svg', top: (requestT === 'viewEvent' && upMD) ? '10px' : '24px', right: (requestT === 'viewEvent' && upMD) ? '60px' : '52px', width: (requestT === 'viewEvent' && upMD) ? '30px' : '16px', height: (requestT === 'viewEvent' && upMD) ? '30px' : '16px' },
			{ src: '/images/icons/Images/yellowBalloon.svg', top: '30px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '70px' : '40px', height: (requestT === 'viewEvent' && upMD) ? '70px' : '60px' },
			{ src: '/images/icons/Images/blueBalloon.svg', top: '40px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '100px' : '70px', height: (requestT === 'viewEvent' && upMD) ? '100px' : '76px' },
			{ src: '/images/icons/Images/bigCake.svg', bottom: '0px', right: '0px', width: (requestT === 'viewEvent' && upMD) ? '120px' : '64px', height: (requestT === 'viewEvent' && upMD) ? '120px' : '64px' }
		]
	};

	return elements[eventType] || [];
};

// Optional: Create a reusable design element component
export const DesignElement = ({ item }) => (
	<Box
		component='img'
		src={item.src}
		sx={{
			position : 'absolute',
			top      : item.top || 'auto',
			bottom   : item.bottom || 'auto',
			left     : 'auto',
			right    : item.right || 'auto',
			width    : `${item.width} !important`,
			height   : `${item.height}!important`,
			'& img'  : {
				width        : 'var(--percent100)',
				height       : 'var(--percent100)',
				objectFit    : 'cover',
				borderRadius : 'var(--pixel8)'
			}
		}}
	/>
);